import { FC } from "react";
import { Link } from "react-router-dom";
// import LanguagePicker from "./LanguagePicker";
import darkLogo from "../../images/logo-black.png";
import lightLogo from "../../images/logo-white.png";
import SideMenu from "./SideMenu";
import AdminNotificationPanel from "../Admin/AdminNotificationPanel";
import { getUserRole, isAdminRoute } from "../../utils/authHelpers";

const Header: FC<HeaderProps> = ({
  mode = "dark",
  type = "normal",
  className,
}) => {
  const isAdmin = () =>
    getUserRole() === "admin" || getUserRole() === "super_admin";
  const showAdminNotifications = isAdmin() && isAdminRoute();

  return (
    <header
      className={`relative w-full self-center flex flex-row justify-center ${className}`}
    >
      <div className=" w-full self-center flex flex-row justify-between items-center max-w-screen-2xl px-6 py-[18px] sm:px-[48px] sm:py-6 ">
        {showAdminNotifications && <AdminNotificationPanel />}

        <Link to="/">
          <img
            src={mode === "dark" ? lightLogo : darkLogo}
            className="h-4 xs:h-[24px]"
            alt="unspokenn"
          />
        </Link>

        <div className="flex items-center gap-2 sm:gap-8">
          {/* <LanguagePicker
            mode={mode === "dark" || type === "landing" ? "dark" : "light"}
          /> */}
          <SideMenu mode={mode} userRole={getUserRole()} />
        </div>
      </div>
    </header>
  );
};

export default Header;

type HeaderProps = {
  mode?: "dark" | "light";
  type?: "landing" | "normal" | "admin";
  className?: string;
};
